import { create } from 'evx'
import 'element-closest'
import Queue from './qf/Queue'
import Helpers from './qf/Helpers'
// import { CartQf } from './qf/cart';
// import GlobalListeners from './qf/global_listeners';
import { Cart } from './qf/qf-Cart'
import { ProductForm } from './qf/qf-ProductForm'

const { detect } = require('detect-browser');

import LazyLoad from './snippets/LazyLoad'
import LazyVideo from './snippets/LazyVideo'
import KeenSlider from './snippets/KeenSlider'
import Product from './snippets/Product'
import MegaMenu from './snippets/MegaMenu'
import ClassChange from './snippets/ClassChange'
import SlideToggle from './snippets/SlideToggle'
import SlideToggleGroup from './snippets/SlideToggleGroup'
import SetCSSVar from './snippets/SetCSSVar'
import SlidingMenu from './snippets/SlidingMenu'
import LockScroll from './snippets/LockScroll';
import ReadMore from './snippets/ReadMore';
import SetDefaultAddress from './snippets/SetDefaultAddress';
import CountryProvinceSelector from './snippets/CountryProvinceSelector';
import QuickBuy from './snippets/QuickBuy';
import StickyElem from './snippets/StickyElem';
import Choices from './snippets/Choices'
import LoadMore from './snippets/LoadMore'
import ShopTheLook from './snippets/ShopTheLook'
import Accordion from './snippets/Accordion'
import BAOAccordionGroup from './snippets/BAOAccordionGroup'
import Header from './snippets/Header'
import CollectionGrid from './snippets/CollectionGrid'
import MainProductGallery from './snippets/MainProductGallery'
import WishlistTrigger from './snippets/WishlistTrigger'
import ProductDescriptionMore from './snippets/ProductDescriptionMore'
import KlevuRecsTabs from './snippets/KlevuRecsTabs'
import KlevuSearchOverlay from './snippets/KlevuSearchOverlay'
import ProductStickyAddToCart from './snippets/ProductStickyAddToCart'
import FooterAccordions from './snippets/FooterAccordions'
import AnimatedSearchText from './snippets/AnimatedSearchText'
import HeaderDropdown from './snippets/HeaderDropdown'
import ThemeGTMDatalayer from './snippets/ThemeGTMDatalayer'
import FeaturedCtaCarousel from './snippets/FeaturedCTACarousel'
import ContentGridCarousel from './snippets/ContentGridCarousel'
import ContentGrid from './snippets/ContentGrid'
import ProductCarousel from './snippets/ProductCarousel'
import Hero from './snippets/Hero'
import CartDrawerUpsells from './snippets/CartDrawerUpsells'
import CartDrawerRecs from './snippets/CartDrawerRecs'
import SiteDrawers from './snippets/SiteDrawers'
import SiteDrawer from './snippets/SiteDrawer'
import QuickAdd from './snippets/QuickAdd'
import ProductCardWishlist from './snippets/ProductCardWishlist'
import HotSpots from './snippets/HotSpots'
import DynamicTextReveal from './snippets/DynamicTextReveal'
import PreOrderController from './snippets/PreOrderController'
import GiftCardPromo from './snippets/GiftCardPromo'
import CollectionHiddenGate from './snippets/CollectionHiddenGate'
import YotpoReviews from './snippets/YotpoReviews'
import CollectionFilters from './snippets/CollectionFilters'
import CollectionAltImagesToggle from './snippets/CollectionAltImagesToggle'
import FacetRemove from './snippets/FacetRemove'
import FilterAccordions from './snippets/FilterAccordions'
import YotpoReviewsStars from './snippets/YotpoReviewsStars'
import StickyHeader from './snippets/StickyHeader'
import CollectionHeader from './snippets/CollectionHeader'
import CollectionClusters from './snippets/CollectionClusters'
import AnimateIn from './snippets/AnimateIn'
import LargeStats from './snippets/LargeStats'
import StickyLeftScrollRight from './snippets/StickyLeftScrollRight'
import DynamicMessagingScroll from './snippets/DynamicMessagingScroll'
import KlaviyoBackInStock from './snippets/KlaviyoBackInStock'
import ProductFeatures from './snippets/ProductFeatures'
import ColourSwatches from './snippets/ColourSwatches'
import ProductOosModal from './snippets/ProductOosModal'
import SizeGuide from './snippets/SizeGuide'

const components = {
  'shop-the-look': ShopTheLook,
  'load-more': LoadMore,
  'choices': Choices,
  'sticky': StickyElem,
  'sliding-menu': SlidingMenu,
  'lock-scroll': LockScroll,
  'set-css-var': SetCSSVar,
  'class-change': ClassChange,
  'slide-toggle': SlideToggle,
  'toggle-group': SlideToggleGroup,
  'mega-menu': MegaMenu,
  'lazy-load': LazyLoad,
  'lazy-video': LazyVideo,
  'keen-slider': KeenSlider,
  'read-more': ReadMore,
  'product': Product,
  'product-ajax': Product,
  'set-default-address': SetDefaultAddress,
  'country-province-selector': CountryProvinceSelector,
  'quick-buy': QuickBuy,
  'accordion': Accordion,
  'bao-accordion-group': BAOAccordionGroup,
  'header': Header,
  'collection-grid': CollectionGrid,
  'main-product-gallery': MainProductGallery,
  'wishlist-trigger': WishlistTrigger,
  'product-description-more': ProductDescriptionMore,
  'klevu-recs-tabs': KlevuRecsTabs,
  'search-overlay': KlevuSearchOverlay,
  'product-sticky-cta': ProductStickyAddToCart,
  'footer-accordions': FooterAccordions,
  'animated-search-text': AnimatedSearchText,
  'header-dropdown': HeaderDropdown,
  'theme-gtm-datalayer': ThemeGTMDatalayer,
  'featured-cta-carousel': FeaturedCtaCarousel,
  'content-grid-carousel': ContentGridCarousel,
  'content-grid': ContentGrid,
  'product-carousel': ProductCarousel,
  'hero': Hero,
  'cart-drawer-upsells': CartDrawerUpsells,
  'cart-drawer-recs': CartDrawerRecs,
  'site-drawers': SiteDrawers,
  'site-drawers': SiteDrawer,
  'quick-add': QuickAdd,
  'product-card-wishlist': ProductCardWishlist,
  'hot-spots': HotSpots,
  'dynamic-text-reveal': DynamicTextReveal,
  'dynamic-messaging-scroll': DynamicMessagingScroll,
  'pre-order-controller': PreOrderController,
  'gift-card-promo': GiftCardPromo,
  'collection-hidden-gate': CollectionHiddenGate,
  'yotpo-reviews': YotpoReviews,
  'collection-filters': CollectionFilters,
  'collection-alt-images-toggle': CollectionAltImagesToggle,
  'facet-remove': FacetRemove,
  'filter-accordions': FilterAccordions,
  'yotpo-reviews-stars': YotpoReviewsStars,
  'sticky-header': StickyHeader,
  'collection-header': CollectionHeader,
  'collection-clusters': CollectionClusters,
  'large-stats': LargeStats,
  'sticky-left-scroll-right': StickyLeftScrollRight,
  'colour-swatches': ColourSwatches,
  'product-oos-modal': ProductOosModal,
  'size-guide': SizeGuide,
}

// Bind any QF components
// window.cart = new CartQf();
// window.globalListeners = new GlobalListeners();

window.Cart = Cart;
window.ProductForm = ProductForm;

const options = {
  turbolinks: false
}

const state = {
  eventQueue: new Queue(),
  ajaxCache: []
}

export default class Theme {
  constructor(ctx = state, passedOptions = {}) {
    this._options = { ...passedOptions, ...options }
    let themeInfoElem = document.querySelector('[data-theme-information]')
    if (themeInfoElem) {
      ctx = { ...ctx, ...JSON.parse(themeInfoElem.innerHTML) }
    }
    this._ctx = create(ctx)
    this._viewportEvent()
    this._bodyScrollListen()
    this._runHooks()
    this._browserDetect()
    this._components = []
  }

  _browserDetect () {
    const browser = detect()
    if (browser) {
      document.body.classList.add(`browser--${Helpers.handleize(browser.name)}`)
      document.body.classList.add(`os--${Helpers.handleize(browser.os)}`)
    }
  }

  _viewportEvent () {
    window.addEventListener('resize', () => {
      this._viewportLogic()
    }, { passive: true })
    this._viewportLogic()
  }

  _bodyScrollListen () {
    const targetNode = document.body
    const config = { attributes: true, childList: false, subtree: false };

    const callback = function (mutationsList, observer) {
      document.documentElement.style.setProperty('--scroll-gap-right', getComputedStyle(document.body).paddingRight)
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  _viewportLogic () {
    let vh = window.innerHeight * 0.01;
    let vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }

  mountComponents (container = document) {
    for (let componentKey in components) {
      if (components.hasOwnProperty(componentKey)) {
        let selector = `[data-${componentKey}]`
        let elements = container.querySelectorAll(selector)
        for (let elem of elements) {
          this.mountComponent(componentKey, componentKey, elem)
        }
      }
    }
    window.__Theme = this
    window.__ThemeComponents = this._components

    this._ctx.emit('ffc--mounted')
  }

  unmountComponents (container = document) {
    for (var i = this._components.length - 1; i >= 0; i--) {
      let component = this._components[i]

      if (container.contains(component.elem)) {
        let componentObj = component.component
        if (typeof componentObj.unmount === 'function') {
          componentObj.unmount()
        }
        component = null
        componentObj = null
        this._components.splice(i, 1)
      }
    }
  }

  mountComponent (type, dataAttr, elem) {
    let optionStr = (elem.getAttribute(`data-${dataAttr}`) || '').trim()
    let options = {}
    if (optionStr.startsWith('{') || optionStr.startsWith('[')) {
      options = JSON.parse(optionStr)
    }
    let compInstance = new components[type](elem, this, options, this._ctx)
    this._components.push({
      type: type,
      elem: elem,
      id: compInstance._options.id,
      component: compInstance
    })

    try {
      compInstance.mount()
    } catch (e) {
      console.error(`-----ERROR IN COMPONENT----- \ntype: ${type}\nelement and stack trace below:`)
      console.error(elem)
      console.error(e)
    }
  }

  getOptions () {
    return this._options
  }

  getComponent (id) {
    return this._components.find(component => component.id === id)
  }

  getComponentByElem (elem) {
    return this._components.find(component => component.elem === elem)
  }

  _runHooks () {
    this._ctx.on('cart-item-added', state => {
      if (window.pintrk) {
        pintrk('track', 'addtocart', {
          value: state.lastItemAdded.item.price / 100.00,
          order_quantity: state.lastItemAdded.quantity
        })
      }
      if (window.fbq) {
        fbq('track', 'AddToCart')
      }
    })
  }
}
